import React, {useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  Pressable,
} from 'react-native';
import {globalFontStyle} from '../../../assets';
import {globalImport} from '../../../common/globalImports';
import Colors from '../../../assets/Color/Colors';

const SubCategories = ({subCategory, onSubCategoryUpdate, selectedSubCategory}) => {
  const [hoveredItem, setHoveredItem] = useState(null);

  const renderSubCategory = (item, index) => {
    const isSelected = selectedSubCategory === item;
    const isHovered = hoveredItem === item;

    return (
      <Pressable
        key={index}
        onPress={() => onSubCategoryUpdate(item)}
        onHoverIn={() => setHoveredItem(item)}
        onHoverOut={() => setHoveredItem(null)}
        style={[
          styles.pillContainer,
          isSelected && styles.selectedPill,
          isHovered && !isSelected && styles.hoveredPill,
        ]}>
        <Text
          style={[
            styles.pillText,
            isSelected && styles.selectedPillText,
            isHovered && !isSelected && styles.hoveredPillText,
          ]}>
          {item}
        </Text>
      </Pressable>
    );
  };

  return (
    <View style={styles.pillsWrapper}>
      {subCategory?.map(renderSubCategory)}
    </View>
  );
};

const styles = StyleSheet.create({
  pillsWrapper: {
    flexDirection: 'row',
    gap: 12,
    flexWrap: 'nowrap',
  },
  pillContainer: {
    paddingHorizontal: 12,
    height: 28,
    borderRadius: 4,
    backgroundColor: Colors.chipBackground,
    borderWidth: 1,
    borderColor: 'transparent',
    transition: 'all 0.2s ease',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    flexShrink: 0,
  },
  selectedPill: {
    backgroundColor: '#000000',
    borderColor: '#000000',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  hoveredPill: {
    backgroundColor: globalImport.isWeb ? '#FFFFFF' : undefined,
    borderColor: '#E0E0E0',
    boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
    transform: 'translateY(-1px)',
  },
  pillText: {
    ...globalFontStyle.appFontRegular,
    color: '#666666',
    fontSize: 13,
    fontWeight: '500',
    letterSpacing: '0.1px',
  },
  selectedPillText: {
    color: '#FFFFFF',
  },
  hoveredPillText: {
    color: '#000000',
  },
});

export default SubCategories;
